import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ChevronLeft, Sprout } from "lucide-react";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";

const D = { navy: "#1e2130", surface: "#292d44", coral: "#f76359" };

export default function MinistryNew() {
  const nav = useNavigate();
  const [groups, setGroups] = useState([]);
  const [name, setName] = useState("");
  const [desc, setDesc] = useState("");
  const [sel, setSel] = useState([]);

  useEffect(() => { api.get("/curator/groups").then(({ data }) => setGroups(data.groups)); }, []);
  const toggle = (id) => setSel(sel.includes(id) ? sel.filter((x) => x !== id) : [...sel, id]);
  const create = async () => {
    if (!name || sel.length === 0) return toast.error("Name the ministry and pick at least one group");
    try { const { data } = await api.post("/curator/ministries", { name, description: desc, group_ids: sel }); toast.success("Ministry created"); nav(`/ministry/${data.id}`); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };
  const inp = "w-full rounded-xl border border-[#faf6f0]/15 bg-[#1e2130] px-3 py-2 text-[#faf6f0] focus:border-[#f76359] focus:outline-none";
  return (
    <div style={{ background: D.navy }} className="min-h-screen text-[#faf6f0]">
      <div className="mx-auto max-w-2xl px-5 py-6 sm:px-8">
        <button onClick={() => nav("/curator")} className="mb-3 flex items-center gap-1 text-sm text-[#faf6f0]/60 hover:text-white"><ChevronLeft size={16} /> Back office</button>
        <div className="flex items-center gap-2 text-[#f76359]"><Sprout size={20} /><span className="text-xs font-bold uppercase tracking-widest">Ministry track</span></div>
        <h1 className="text-2xl font-extrabold sm:text-3xl">Start a ministry</h1>
        <p className="mt-1 text-sm text-[#faf6f0]/70">Group several consistent studies under one ministry with its own page and leader dashboard.</p>
        <div className="mt-5 space-y-3">
          <input className={inp} data-testid="ministry-name" value={name} onChange={(e) => setName(e.target.value)} placeholder="Ministry name" />
          <textarea className={inp} rows={2} data-testid="ministry-desc" value={desc} onChange={(e) => setDesc(e.target.value)} placeholder="What this ministry is about" />
          <div className="rounded-xl p-4" style={{ background: D.surface }}>
            <div className="mb-2 text-sm font-semibold">Include groups</div>
            {groups.map((g) => (
              <label key={g.id} className="flex items-center gap-2 py-1.5 text-sm">
                <input type="checkbox" data-testid={`ministry-pick-${g.id}`} checked={sel.includes(g.id)} onChange={() => toggle(g.id)} /> {g.title} <span className="text-[#faf6f0]/40">· {g.confirmed} members</span>
              </label>
            ))}
          </div>
          <button className="inline-flex items-center gap-2 rounded-full bg-[#f76359] px-5 py-2.5 text-sm font-semibold text-white hover:bg-[#e2554c]" data-testid="ministry-create" onClick={create}>Create ministry</button>
        </div>
      </div>
    </div>
  );
}
